import React from 'react';
import {Route, Routes} from 'react-router-dom';
import LoginPage from 'pages/Login/LoginPage';
import NotAuthorizedPage from "pages/NotAuthorized/NotAuthorizedPage";
import NotFoundPage from "pages/NotFound/NotFoundPage";
import HomePage from "pages/HomePage/HomePage";
import PrivateRoute from "./PrivateRoute";
import CompaniesPage from "pages/Company/CompaniesPage";
import CompanyUsersPage from "pages/CompanyUser/CompanyUsersPage";
import CompanyInvitationPage from "pages/CompanyInvitation/CompanyInvitationPage";
import CompanyInvitationConfirmationPage from "pages/CompanyInvitationConfirmation/CompanyInvitationConfirmationPage";
import ForgotPasswordPage from "../pages/ForgotPassword/ForgotPasswordPage";
import ForgotPasswordThankYouPage from "../pages/ForgotPassword/ForgotPasswordThankYouPage";
import ResetPasswordPage from "../pages/ResetPassword/ResetPasswordPage";
import ResetPasswordThankYouPage from "../pages/ResetPassword/ResetPasswordThankYouPage";
import KPITargetPage from "../pages/KPITarget/KPITargetPage";
import CompanyModal from "../pages/Company/CompanyModal";
import KPIValuePage from "../pages/KPIValue/KPIValuePage";
import KPIValueTargetPopup from "../pages/KPIValue/KPIValueTargetPopup";
import KPITargetModal from "../pages/KPITarget/KPITargetModal";
import PriorityPlannerPage from "../pages/PriorityPlanner/PriorityPlannerPage";
import PriorityPlannerModal from "../pages/PriorityPlanner/PriorityPlannerModal";
import SAMPage from "../pages/SAM/SAMPage";
import SAMTaskModal from "../pages/SAM/SAMTaskModal";
import SAMMeetingModal from "../pages/SAM/SAMMeetingModal";
import SAMAgendaModal from "../pages/SAM/SAMAgendaModal";
import CompanyUserModal from "../pages/CompanyUser/CompanyUserModal";
import LocationPage from "../pages/Location/LocationPage";
import LocationModal from "../pages/Location/LocationModal";
import CompanyRoadmapPage from "../pages/CompanyRoadmap/CompanyRoadmapPage";
import MCAPPage from "../pages/MCAP/MCAPPage";
import OrganizationalIndexPage from "../pages/OrganizationalIndex/OrganizationalIndexPage";
import OrganizationalIndexModal from "../pages/OrganizationalIndex/OrganizationalIndexModal";
import PriorityTaskModal from 'pages/PriorityPlanner/PriorityTaskModal';
import KPITaskModal from '../pages/KPITarget/KPITaskModal';
import ManageTeamPage from 'pages/ManageTeam/ManageTeamPage';
import KPITaskSummary from '../pages/ProductivityReports/KPITaskSummary'

const BusinessScapeRoutes = () => {
    return (<Routes>
        <Route path="/" element={<PrivateRoute />}>
            <Route path="" element={<HomePage />}>
                <Route path="popup/:target" element={<KPIValueTargetPopup />} />
                <Route path="priority-sub-task/:priority/task/:task/parent-task/:parentTask" element={<PriorityTaskModal />} />
                <Route path="sam-sub-task/:meeting/task/:task/parent-task/:parentTask" element={<SAMTaskModal />} />
                <Route path="kpi-sub-task/:target/task/:task/parent-task/:parentTask" element={<KPITaskModal />} />
                <Route path="priority-edit-task/:task" element={<PriorityTaskModal />} />
                <Route path="sam-edit-task/:task" element={<SAMTaskModal />} />
                <Route path="kpi-edit-task/:task" element={<KPITaskModal />} />
            </Route>
        </Route>
        <Route path="/auth">
            <Route path="login" element={<LoginPage />} />
            <Route path="forgot-password" element={<ForgotPasswordPage />} />
            <Route path="forgot-password-thankyou" element={<ForgotPasswordThankYouPage />} />
            <Route path="reset-password" element={<ResetPasswordPage />} />
            <Route path="reset-password-thankyou" element={<ResetPasswordThankYouPage />} />
            <Route path="not-authorized" element={<NotAuthorizedPage />} />
            <Route path="company-invitation" element={<CompanyInvitationPage />} />
            <Route path="company-invitation-confirmation" element={<PrivateRoute />}>
                <Route path="" element={<CompanyInvitationConfirmationPage />} />
            </Route>
        </Route>
        <Route path="/company-roadmap" element={<PrivateRoute />}>
            <Route path="" element={<CompanyRoadmapPage />} />
        </Route>
        <Route path="/kpi">
            <Route path="kpis" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin', 'CompanyManager', 'CompanyUser']} />}>
                <Route path="" element={<KPIValuePage />}>
                    <Route path="popup/:target" element={<KPIValueTargetPopup />} />
                </Route>
            </Route>
        </Route>
        <Route path="/super-admin">
            <Route path="companies" element={<PrivateRoute roles={['SuperAdmin']} />}>
                <Route path="" element={<CompaniesPage />}>
                    <Route path="edit/:company" element={<CompanyModal />} />
                </Route>
            </Route>
        </Route>
        <Route path="/company-admin">
            <Route path="users" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin']} />}>
                <Route path="" element={<CompanyUsersPage />}>
                    <Route path="edit/:companyuser" element={<CompanyUserModal />} />
                </Route>
            </Route>
            <Route path="organizational-index" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin', 'CompanyManager', 'CompanyUser']} />}>
                <Route path="" element={<OrganizationalIndexPage />}>
                    <Route path="create/:parent/:department" element={<OrganizationalIndexModal />} />
                    <Route path="edit/:department" element={<OrganizationalIndexModal />} />
                </Route>
            </Route>
            <Route path="locations" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin']} />}>
                <Route path="" element={<LocationPage />}>
                    <Route path="edit/:location" element={<LocationModal />} />
                </Route>
            </Route>
            <Route path="priority-planner" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin']} />}>
                <Route path="" element={<PriorityPlannerPage />}>
                    <Route path="edit/:priority" element={<PriorityPlannerModal />}>
                        <Route path="task/:task" element={<PriorityPlannerModal />} />
                        <Route path="task/:task/parent-task/:parentTask" element={<PriorityPlannerModal />} />
                    </Route>
                </Route>
            </Route>
            <Route path="shared-action-meetings" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin']} />}>
                <Route path="" element={<SAMPage />}>
                    <Route path="edit-task/:task" element={<SAMTaskModal />} />
                    <Route path="edit-task/:task/parent-task/:parentTask" element={<SAMTaskModal />} />
                    <Route path="edit-meeting/:meeting" element={<SAMMeetingModal />} />
                    <Route path="edit-agenda/:meeting" element={<SAMAgendaModal />}>
                        <Route path="task/:task" element={<SAMAgendaModal />} />
                        <Route path="task/:task/parent-task/:parentTask" element={<SAMAgendaModal />} />
                    </Route>
                </Route>
            </Route>
            <Route path="growth-plan-management" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin']} />}>
                <Route path="" element={<KPITargetPage />}>
                    <Route path="edit/:target" element={<KPITargetModal />}>
                        <Route path="task/:task" element={<KPITargetModal />} />
                        <Route path="task/:task/parent-task/:parentTask" element={<KPITargetModal />} />
                    </Route>
                </Route>
            </Route>
            <Route path="manage-team" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin', 'CompanyManager']} />}>
                <Route path="" element={<ManageTeamPage />}>
                    <Route path="priority-sub-task/:priority/task/:task/parent-task/:parentTask" element={<PriorityTaskModal />} />
                    <Route path="sam-sub-task/:meeting/task/:task/parent-task/:parentTask" element={<SAMTaskModal />} />
                    <Route path="kpi-sub-task/:target/task/:task/parent-task/:parentTask" element={<KPITaskModal />} />
                    <Route path="priority-edit-task/:task" element={<PriorityTaskModal />} />
                    <Route path="sam-edit-task/:task" element={<SAMTaskModal />} />
                    <Route path="kpi-edit-task/:task" element={<KPITaskModal />} />
                    <Route path="edit/:target" element={<KPITargetModal />}>
                        <Route path="task/:task" element={<KPITargetModal />} />
                        <Route path="task/:task/parent-task/:parentTask" element={<KPITargetModal />} />
                    </Route>
                </Route>
            </Route>
            <Route path="mcap">
                <Route path="standards-guidelines" element={<PrivateRoute roles={['CompanyOwner','CompanyAdmin', 'CompanyManager', 'CompanyUser']} />}>
	                <Route path="" element={<MCAPPage type="StandardsGuidelines" />}/>
	            </Route>
            </Route>
        </Route>
        <Route path="productivity-reports" element={<PrivateRoute roles={['CompanyOwner', 'CompanyAdmin', 'CompanyManager']} />}>
                <Route path="task-summary" element={<KPITaskSummary />}>
                </Route>
        </Route>
        <Route element={<NotFoundPage />} />
    </Routes>);
}

export default BusinessScapeRoutes;
